import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useAutoScrollToLastActive } from '../../internal/hooks';
import { AccordionItem } from '../../internal/components';
import { ALLOW_ONLY_ONE_OPENED, AUTO_SCROLL_TO_LAST_ACTIVE, SIZE, TEST_ID } from '../../internal/constants';
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонент аккордеона. Принимает массив айтемов, отображая каждый из них как отдельный раскрывающийся блок.
 * Дополнительно может задавать им особое поведение.
 */
export var Accordion = function Accordion(_ref) {
  var items = _ref.items,
    onItemClick = _ref.onItemClick,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? TEST_ID : _ref$testId,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? SIZE : _ref$size,
    _ref$autoScrollToLast = _ref.autoScrollToLastActive,
    autoScrollToLastActive = _ref$autoScrollToLast === void 0 ? AUTO_SCROLL_TO_LAST_ACTIVE : _ref$autoScrollToLast,
    _ref$allowOnlyOneOpen = _ref.allowOnlyOneOpened,
    allowOnlyOneOpened = _ref$allowOnlyOneOpen === void 0 ? ALLOW_ONLY_ONE_OPENED : _ref$allowOnlyOneOpen;
  var accordionItemsRef = React.useRef([]);
  var _React$useState = React.useState(function () {
      return items.reduce(function (acc, curr, i) {
        if (curr.defaultOpen) {
          acc.push(i);
        }
        return acc;
      }, []);
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    openedItems = _React$useState2[0],
    setOpenedItems = _React$useState2[1];
  var _useAutoScrollToLastA = useAutoScrollToLastActive({
      accordionItemsRef: accordionItemsRef
    }),
    scrollToLastActive = _useAutoScrollToLastA.scrollToLastActive;
  var onAccordionItemClick = function onAccordionItemClick(args) {
    var target = args.target,
      open = args.open,
      index = args.index;
    if (open) {
      setOpenedItems(function (items) {
        return items.filter(function (item) {
          return item !== index;
        });
      });
    } else if (allowOnlyOneOpened) {
      setOpenedItems(function () {
        return [index];
      });
    } else {
      setOpenedItems(function (items) {
        return [].concat(_toConsumableArray(items), [index]);
      });
    }
    if (onItemClick) {
      /**
       * На момент клика "open" еще хранит предыдущее состояние, поэтому чтобы
       * сказать "айтем только что открылся/закрылся" нужно инвертировать это значение
       */
      onItemClick({
        target: target,
        index: index,
        open: !open
      });
    }
    if (autoScrollToLastActive) {
      scrollToLastActive(index);
    }
  };
  return /*#__PURE__*/_jsx("div", {
    "data-testid": testId,
    children: items.map(function (item, index) {
      var isOpen = openedItems.some(function (itemIndex) {
        return itemIndex === index;
      });
      var handleClick = function handleClick() {
        return onAccordionItemClick({
          index: index,
          target: item,
          open: isOpen
        });
      };
      return /*#__PURE__*/_createElement(AccordionItem, _objectSpread(_objectSpread({}, item), {}, {
        key: index,
        ref: function ref(_ref2) {
          return accordionItemsRef.current[index] = _ref2;
        },
        index: index,
        size: size,
        open: isOpen,
        handleClick: handleClick
      }));
    })
  });
};